import React from "react"
import {StoresContext} from "../mobx/context"

export const UseStores = () => React.useContext(StoresContext)
